import type { DisplayCardCanonicalVariant, DisplayCardVariant } from './DisplayCard'

const VARIANT_ALIAS: Record<DisplayCardVariant, DisplayCardCanonicalVariant> = {
  action: 'action',
  tracker: 'tracker',
  chip: 'chip',
  showcase: 'showcase',
  playingCard: 'playingCard',
  primary: 'action',
  secondary: 'tracker',
  tertiary: 'chip',
  quaternary: 'showcase',
}

export const normalizeDisplayCardVariant = (variant: DisplayCardVariant): DisplayCardCanonicalVariant =>
  VARIANT_ALIAS[variant]
